import React from 'react';

export const FullboardIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 2 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width={width} height={height} rx="12" fill="white" />
        <path
          d="M3.73 12.834H8.784V14.038H3.73V12.834ZM3.87 18H2.47V8.2H9.386V9.418H3.87V18ZM11.7767 18V8.2H16.1727C17.3021 8.2 18.1701 8.42867 18.7767 8.886C19.3834 9.334 19.6867 9.95 19.6867 10.734C19.6867 11.266 19.5654 11.714 19.3227 12.078C19.0894 12.442 18.7721 12.722 18.3707 12.918C17.9694 13.114 17.5354 13.212 17.0687 13.212L17.3207 12.792C17.8807 12.792 18.3754 12.89 18.8047 13.086C19.2341 13.282 19.5747 13.5713 19.8267 13.954C20.0787 14.3273 20.2047 14.794 20.2047 15.354C20.2047 16.194 19.8874 16.8473 19.2527 17.314C18.6274 17.7713 17.6941 18 16.4527 18H11.7767ZM13.1767 16.866H16.3967C17.1714 16.866 17.7641 16.7353 18.1747 16.474C18.5854 16.2127 18.7907 15.802 18.7907 15.242C18.7907 14.6727 18.5854 14.2573 18.1747 13.996C17.7641 13.7347 17.1714 13.604 16.3967 13.604H13.0507V12.47H16.0467C16.7561 12.47 17.3067 12.3393 17.6987 12.078C18.0907 11.8167 18.2867 11.4247 18.2867 10.902C18.2867 10.3793 18.0907 9.98733 17.6987 9.726C17.3067 9.46467 16.7561 9.334 16.0467 9.334H13.1767V16.866Z"
          fill={fill}
        />
      </svg>
    </div>
  );
};
